module.exports = __webpack_public_path__ + "img/appAsset-cardbrand--Discover.ac52cd46.svg";